import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import ControlledGrid from '../Helper/ControlledGrid';
import Status from '../Helper/Status';
import AbstractEntity from './AbstractEntity';
import Contact from './Contact';

/**
* Class ListeDiffusion
* ListeDiffusion view component
**/
class ListeDiffusion extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "ListeDiffusion";
  }

  /**
  * componentDidUpdate
  * Refreshes the contact cbx
  **/
  componentDidUpdate() {
    if(this.refs.contactsGrid && this.refs.contactsGrid.refs.advancedCbxContact)
      this.refs.contactsGrid.refs.advancedCbxContact.refresh();
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return <div></div>;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de liste de diffusion.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idListeDiffusion" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idListeDiffusion")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="interne" style={{ display: 'none'}}>
            <Col smOffset={2} sm={2}><Checkbox name="interne"
              onChange={(event) => {
                this.setState({...this.state, showExterne: event.target.checked});
              }}
              checked={this.state.showExterne === true} disabled={this.getReadOnly()}>Afficher les contacts externes</Checkbox></Col>
          </FormGroup>

          {/* Contact ManyToMany */}
          <FormGroup controlId="contacts">
            <Col componentClass={ControlLabel} sm={2}>Contacts</Col>
            <Col sm={6}>
              <ControlledGrid ref="contactsGrid" path="contacts" objectPath={`listediffusions_contacts/${this.state.object.idListeDiffusion}/contacts`}
                customFieldsUrl="fields-listediffusion"
                objectClass={Contact} mode={this.state.mode}
                cbxUrl={`${REST_API_URL}listediffusions_contacts/${this.state.object.idListeDiffusion}/contacts/inverse/`}
                cbxParams={!this.state.showExterne ? "?interne=true" : ""}
                optionValueKey="idContact" optionLabelKey="fullName" />
            </Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idListeDiffusion";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let listeDiffusionObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.contactsGrid !== undefined) listeDiffusionObj.contacts = this.refs.contactsGrid.getArrayToSave();
    }

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(listeDiffusionObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();

        this.setState({
          status: {
            type: 'success',
            message: 'Liste de diffusion sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);

        const state = {
          status: {
            type: 'success',
            message: 'Liste de diffusion créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/listediffusions/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.contactsGrid !== undefined) this.refs.contactsGrid.saveAll();
  }

}
export default ListeDiffusion;



// WEBPACK FOOTER //
// ./src/views/Entity/ListeDiffusion.js